module.exports = __webpack_public_path__ + "img/learningCoursesTX.56b29ec6.png";